const dashboardDanish = {
  greeting: {
    morning: "God morgen",
    afternoon: "God eftermiddag",
    evening: "God aften"
  },
  recentActivity: {
    title: "Seneste Aktivitet",
    empty: "Ingen aktivitet at vise endnu"
  },
  notifications: {
    title: "Notifikationer",
    loading: "Indlæser notifikationer...",
    newPost: "Nyt LinkedIn-opslag klar!",
    seeAll: "Se alle {count} opslag",
    empty: "Ingen notifikationer at vise"
  }
};

export default dashboardDanish; 